























import { defineComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  props: {
    title: { type: String, required: true },
    iconWrapperClass: { type: String, default: null },
    iconData: { type: Object, required: true },
    fallbackIcon: { type: Object, default: null },
    tag: { type: String, default: null },
    cols: { type: String, default: null },
    md: { type: String, default: null }
  }
})
